import React from "react";
import helpTexts from "../../../../assets/texts/helpTexts";

const haklaiHelpTexts = {
  ...helpTexts,
  parcelAddressSearch: (
    <div>
      <p>
        ניתן לאתר <strong>גוש וחלקה</strong> לפי <strong>כתובת</strong> בשירות המיפוי הממשלתי: הזינו כתובת בשורה אחת ולחצו על הכפתור{" "}
        <strong>חפש גוש/חלקה</strong>.
      </p>
      <p>
        <strong>פורמט מומלץ:</strong> שם רחוב, מספר בית, פסיק (או רווח), ואז שם היישוב — בדומה לחיפוש כתובות בישראל.
      </p>
      <p>
        <strong>דוגמאות:</strong> <em>הרצל 10, תל אביב</em> · <em>עין גדי 32, אילת</em>
      </p>
      <p>
        <strong>אופציונלי:</strong> ניתן לדלג על הכתובת ולהזין <strong>גוש</strong> ו<strong>חלקה</strong> ידנית; בעת יציאה מהשדות האלו תתבצע בדיקה מול המפה.
      </p>
    </div>
  ),
  wayOfGettingProperty: (
    <div>
      <strong>רכישה</strong>
      <p>רכישת הנכס בתמורה, בין אם במזומן, בהלוואה, או בכל דרך אחרת של תשלום.</p>
      <strong>ירושה</strong>
      <p>
        קבלת הנכס בירושה ממוריש. בעת בחירה באפשרות זו, יש למלא את פרטי המוריש (תאריך פטירה ותאריך רכישת הנכס על ידי המוריש).
      </p>
      <strong>מתנה מקרוב</strong>
      <p>
        קבלת לפחות 50% ממחיר הדירה במתנה, בתוך שלוש שנים שקדמו לרכישתה, תיחשב כדירה שנתקבלה במתנה. במכירה של חלק מהזכויות בנכס, יש
        להזין את השווי המלא של הרכישה במתנה.
      </p>
    </div>
  ),
  isGiftPropertyFromRelated: (
    <p>
      "קרוב"- אחד מאלה: בן זוג, הורה, הורי הורה, צאצא, צאצאי בן זוג, אח, אחות, בני זוגם של כל אחד מהנ"ל, איגוד שהוא בשליטתו.
      <br />
      "מתנה מקרוב" - האם קיבלת לפחות 50% ממחיר הדירה המלא במתנה, בתוך שלוש השנים שקדמו לרכישתה? (במקרה של דירה שבנייתה טרם הושלמה,
      יראו את מועד השלמת בנייתה כמועד קבלתה במתנה).
    </p>
  )
};

export default haklaiHelpTexts;
